module.exports = __webpack_public_path__ + "media/images/home/icon-5-c36f01a93832841abe792458d5a1233d.png";